var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66699 3.99967C2.66699 3.63148 2.96547 3.33301 3.33366 3.33301H12.667C13.0352 3.33301 13.3337 3.63148 13.3337 3.99967C13.3337 4.36786 13.0352 4.66634 12.667 4.66634H3.33366C2.96547 4.66634 2.66699 4.36786 2.66699 3.99967Z",
    fill: "#667185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 7.99967C4.00033 7.63148 4.2988 7.33301 4.66699 7.33301H11.3337C11.7018 7.33301 12.0003 7.63148 12.0003 7.99967C12.0003 8.36786 11.7018 8.66634 11.3337 8.66634H4.66699C4.2988 8.66634 4.00033 8.36786 4.00033 7.99967Z",
    fill: "#667185"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 11.333C5.63214 11.333 5.33366 11.6315 5.33366 11.9997C5.33366 12.3679 5.63214 12.6663 6.00033 12.6663H10.0003C10.3685 12.6663 10.667 12.3679 10.667 11.9997C10.667 11.6315 10.3685 11.333 10.0003 11.333H6.00033Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.7fda6fc4dab427e54ea3524448c944a8.svg";
export { ForwardRef as ReactComponent };